import { HeaderProps } from "@/src/layout/header/desktop/v1";

export const menuItemsProps: HeaderProps["menuItems"] = [
  {
    label: "الرئيسية",
    href: "/ar",
  },
  {
    label: "من نحن",
    href: "/ar/about",
  },
  {
    label: "الخدمات",
    href: "/ar/services",
  },
  {
    label: "الحلول",
    href: "/ar/solutions",
  },
  {
    label: "المشاريع",
    href: "/ar/project",
  },
  {
    label: "الوظائف",
    href: "/ar/careers",
  },
  {
    label: "الاخبار",
    href: "/ar/news",
  },
  {
    label: "تواصل معنا",
    href: "/ar/contact",
  },
];
